import React from 'react';
import { TestimonialCard } from '../components/TestimonialCard';
import { FooterCTA } from '../components/FooterCTA';
import { testimonials } from '../components/testimonials';
export function Testimonials() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-1160" data-mp="2z9gh894zqo3b">
      {/* HERO */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32 text-center" data-id="element-1161" data-mp="2ucgarx48bjbo">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-1162" data-mp="26mvmqzt7xvvj"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-1163" data-mp="21kwkxud4n70p"></div>
        <div className="max-w-[900px] mx-auto px-5 md:px-12 relative z-10" data-id="element-1164" data-mp="2bjm3zqgrexij">
          <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6" data-id="element-1165" data-mp="1nu1kn6gp1y8q">
            Povești de Succes
          </h1>
          <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] max-w-[700px] mx-auto" data-id="element-1166" data-mp="1ug4z78t8bkir">
            Descoperă cum PROVI System a transformat companiile antreprenorilor
            cu care am lucrat. De la haos operațional, la sisteme care
            funcționează independent de fondator.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS GRID */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-1167" data-mp="1bhst5vxm6qre">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-1168" data-mp="1bjdj188zhlix">
          <div className="grid md:grid-cols-3 gap-8" data-id="element-1169" data-mp="1fj4j62kehe04">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-1170" data-mp="1kgnvgwxjfgpf" data-mpi={i} />)}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <FooterCTA data-id="element-1171" data-mp="1pid98kc5a8h7" />
    </div>;
}